export default "__VITE_ASSET__DO_$9oWW__"